import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { CheckoutsCreateStep } from "@src/widgets/onboarding/classes/tours/CryptoPaymentsTour/steps/CheckoutsCreateStep"
import { CheckoutsEditStep } from "@src/widgets/onboarding/classes/tours/CryptoPaymentsTour/steps/CheckoutsEditStep"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"

export class CryptoPaymentsTour extends BaseTour {
  name = ONBOARDING_TOURS.CRYPTO_PAYMENTS

  steps = [new CheckoutsCreateStep(), new CheckoutsEditStep()]
}
